<section class="masthead-page masthead-dieta-chetogenica montserrat">
    <p class="card-text montserrat text-center">PROTOCOLLO CHETOGENICO L-AMINO</p>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="row">

        <div class="col-11 pt-5 pb-4">

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Protocollo Chetogenico</li>
                </ol>
            </nav>
    
        </div>

    </div>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="col-11 mt-3 marginauto">
        <div class="text text-justify pb-3">
            <div class="row">
                <div class="col mb-3">Protocolli chetogenici:</div>
            </div>

                <div class="row mb-5 alimentarsi-oggi montserrat">
                    <div class="col">
                        <h2 class="mb-2">L-AMINO (20+20) -  Protocollo Ferrero</h2>
                        <p>Il protocollo chetogenico intensivo vlckd <b>L-Amino</b> formulato dal dottor Ferrero Leone ha una durata di 20 giorni (ripetibili) e prevede:</p>

                        <ul>
                            <li>Colazione, 2 misurini del preparato (16 grammi) ai quali aggiungere bevande senza zucchero a proprio gusto.</li>
                            <li>Pranzo: 4 misurini del preparato (32 grammi) ai quali aggiungere una porzione abbondante di ortaggi concessi in chetogenica.</li>
                            <li>Cena, con cibi naturali cioè secondo proteico e contorno di ortaggi concessi*.</li>
                        </ul>

                        <p>A gusto la cena si può invertire con il pranzo, le porzioni di proteine naturali* e ortaggi si stabiliscono in base ai parametri antropometrici e alle abitudini del paziente, il protocollo è sempre personalizzato.</p>

                        <p>La confezione da 60 dosi è sufficiente per il primo ciclo di 20 giorni, in base ai risultati raggiunti si valuterà se procedere con una seconda fase di ulteriori 20 giorni oppure passare al mantenimento. L- Amino si scioglie in poca acqua, si può insaporire con caffè e si mangia con il cucchiaino oppure si può mescolare alla bevanda preferita.</p>

                        <p>N.B. In base al totale calorico previsto nel singolo protocollo si possono inserire a gusto snack e alimenti della linea Leone Lifestyle.</p>
                        <h3 class="mb-2">Drenaggio e detossificazione</h3>

                        <p>Per favorire l’eliminazione delle tossine e contrastare il ristagno linfatico è sempre bene favorire le funzioni fisiologiche di drenaggio e depurazione dei tessuti e degli organi. Il Protocollo chetogenico L-AMINO prevede la sinergia di due integratori fitoterapici con queste specifiche indicazioni da assumere come se segue.</p>

                        <div class="row mt-5">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <h3 class="mb-2">L-DRENA 200ml:</h3>
                                fase <b>urto</b>, 10 giorni: 10ml in un bicchiere d’acqua al mattino appena svegli e 10 ml un’ora dopo cena;
                                fase di <b>mantenimento</b>, dall’11° giorno in poi: 10 ml la sera un’ora dopo cena.
                            </div>

                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="row">
                                    <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 col-10 marginauto mt-xl-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
                                        <div class="card marginauto">
                                            <img class="lazyload card-img-top" data-src="./assets/products/L-Drena-sm.jpg" alt="L-Drena" title="L-Drena">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row my-5">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <h3 class="mb-2">L-DETOX 200ml:</h3>
                                fase <b>urto</b>, 10 giorni, 10 ml in un bicchiere d’acqua 15 minuti prima di cena e 10 ml un’ora dopo cena (insieme a L-DRENA); 
                                fase di <b>mantenimento</b>, dall’11° giorno in poi, 10 ml la sera un’ora dopo cena (insieme a L-DRENA).
                            </div>

                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="row">
                                    <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 col-10 marginauto mt-xl-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
                                        <div class="card marginauto">
                                            <img class="lazyload card-img-top" data-src="./assets/products/L-Detox-sm.jpg" alt="L-Detox" title="L-Detox">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p>Per praticità L-Drena e L-Detox nelle quantità previste si possono versare in 1 litro d’acqua da sorseggiare nella giornata.</p>

                        <div class="row mb-2">
                            <div class="col kn">
                                <p class='alert alert-success mt-3 mb-3' role='alert'>(*) Elenco dei principali alimenti concessi in dieta chetogenica, i quantitativi devono essere personalizzati così come la quota e le fonti di grassi previsti.</p>
                            </div>
                        </div>

                        <p><b>PROTEINE ANIMALI</b>: tutte indistintamente, carne, pesce, uova, lavorati. ORTAGGI: alghe marine, asparagi, broccoli, carciofi, cavoletti di Bruxelles, cavolfiore, cardi, cavolo cappuccio, cetriolo, crauti, crescione, cicoria, finocchi, funghi, indivia, prezzemolo, basilico, radicchio, ravanelli, rucola, scalogno, sedano, spinaci, tarassaco, verdure a foglia verde, verza, spinaci, zucchine, insalata, minestrone con verdure in elenco.</p>

                        <div class="row mb-2">
                            <div class="col kn">
                                <p class='alert alert-warning mt-3 mb-3' role='alert'><b>AVVERTENZE</b>: Tutti i contenuti presentati in questo sito sono di carattere puramente informativo e non possono essere intesi in alcun modo come prescrizioni di tipo medico né possono essere ad esse sostituite. Queste spettano esclusivamente ai professionisti abilitati che possano valutare eventuali rischi.</p>
                            </div>
                        </div>

                    </div>
                </div>

        </div>
    </div>

    <div class="col-11 pt-5 pb-4">

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Protocollo Chetogenico</li>
            </ol>
        </nav>

    </div>


</section>

<section class="py-3"></section>
